"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var collectPos = {
  status: false,
  nodeArr: [],
  arr: []
};
var Netvigator = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _a;
  var theme = props.theme,
    selected = props.selected,
    divider = props.divider,
    display = props.display,
    size = props.size,
    bold = props.bold,
    className = props.className,
    children = props.children,
    onClick = props.onClick,
    moveToNode = props.moveToNode,
    requestanimationframefunc = props.requestanimationframefunc,
    _b = props.colorTheme,
    colorTheme = _b === void 0 ? '' : _b,
    restProps = __rest(props, ["theme", "selected", "divider", "display", "size", "bold", "className", "children", "onClick", "moveToNode", "requestanimationframefunc", "colorTheme"]);
  // console.log(props, 'xxx')
  // const [fixed, setFixed] = useState(false)
  // const [heading, setHeading] = useState('')
  var _c = (0, _react.useState)(selected),
    position = _c[0],
    setPosition = _c[1];
  var fixedTop = (0, _react.useCallback)(function () {
    // var d = document.getElementById('fixed-menu') as HTMLElement;
    // var fixedTop = d.offsetTop || 0;
    var scrollTop = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
    // console.log('scrollTop')
    // console.log(scrollTop)
    // console.log('fixedTop')
    // console.log(fixedTop)
    if (children) {
      collectPos.nodeArr = [];
      collectPos.arr = [];
      children.forEach(function (item, index) {
        var props = (item || {}).props;
        var link = (props || {}).link;
        var linkElement = document.getElementById(link) || {};
        var linkFixedTop = linkElement.offsetTop || 0;
        if (linkFixedTop >= scrollTop) {
          collectPos.arr.push(index);
          collectPos.status = true;
        }
        collectPos.nodeArr.push(linkFixedTop);
      });
    }
    // console.log(collectPos);
    setPosition(collectPos.status ? collectPos.arr[0] : 0);
  }, [position]);
  (0, _react.useEffect)(function () {
    try {
      if (!collectPos.status) {
        setTimeout(function () {
          window.scroll(0, 0);
        });
      }
    } catch (err) {}
    if (children && collectPos.nodeArr && !collectPos.nodeArr.length) {
      if ('forEach' in children) {
        children.forEach(function (item, _index) {
          var props = (item || {}).props;
          var link = (props || {}).link;
          var linkElement = document.getElementById(link);
          var linkFixedTop = linkElement ? linkElement.offsetTop : 0;
          // var linkFixedTop = linkElement.offsetTop || 0;
          collectPos.nodeArr.push(linkFixedTop);
        });
      }
    }
    if (position) {
      // console.log('selected')
      // console.log(position)
      // console.log(fixed)
      //    {Children.map(children, (child, i) => {
      //     if(i == position){
      //         const _child = child as NetvigatorItemElement
      //         switch the selection content
      //         setHeading(_child.props.children)
      //     }
      //     })}
    }
    // if (0) {
    try {
      window.addEventListener('scroll', (0, _utils.throttle)(fixedTop, 100));
    } catch (err) {}
    // }
    // window.addEventListener("rellocateBlock", fixedTop)
  }, []);
  var isInContainer = function isInContainer(el, container) {
    if (!el || !container) return false;
    var elRect = el.getBoundingClientRect();
    var containerRect;
    if ([window, document, document.documentElement, null, undefined].includes(container)) {
      containerRect = {
        top: 0,
        right: window.innerWidth,
        bottom: window.innerHeight,
        left: 0
      };
    } else {
      containerRect = container.getBoundingClientRect();
    }
    return elRect.left - containerRect.left;
    // return elRect.top < containerRect.bottom &&
    //     elRect.bottom > containerRect.top &&
    //     elRect.right > containerRect.left &&
    //     elRect.left < containerRect.right;
  };
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref,
    // id='fixed-menu'
    className: (0, _classnames["default"])('tci-netvigator', (_a = {}, _a["tci-netvigator-" + size] = size, _a["tci-netvigator-" + theme] = theme, _a['tci-netvigator-bold'] = bold, _a.divider = divider, _a.fixed = true, _a), className)
  }, restProps), _react.Children.map(children, function (child, i) {
    var _a;
    var isSelect = false;
    if (i === position) {
      isSelect = true;
    }
    var soupContent = /*#__PURE__*/_react["default"].createElement("div", {
      onClick: function onClick(e) {
        var props = (child || {}).props;
        var _a = props || {},
          record = _a.record,
          onTabClick = _a.onTabClick;
        // onTabClick && onTabClick(record, i, e);
        onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick(record, i, e);
        setPosition(i);
        collectPos.status = false;
        // console.log(i);
        // debugger;
        // console.log(moveToNode().childNodes[i])
        // moveToNode().scrollLeft = moveToNode().childNodes[i].offsetLeft / 2 + 100;
        // const elementOffsetLeft = moveToNode().childNodes[i].offsetLeft;
        var elementClientWidth = moveToNode().childNodes[i].clientWidth / 2;
        var visualWidth = moveToNode().clientWidth / 2;
        var countScrollWidth = moveToNode().scrollWidth;
        // const currentDistance = elementOffsetLeft + elementClientWidth / 2 - visualWidth;
        var countScrollVal = countScrollWidth - moveToNode().clientWidth;
        // 每个像素滚动值对应总滚动距离
        var everyPx = countScrollVal / countScrollWidth;
        var juli = isInContainer(moveToNode().childNodes[i], moveToNode()) || 0;
        // console.log(juli - visualWidth)
        // console.log((juli - visualWidth) * everyPx, everyPx)
        window.scrollTo(0, collectPos.nodeArr[i] - 100);
        // @ts-ignore
        if (juli - visualWidth > 0) {
          // 当前元素在三八线右边
          // requestanimationframefunc &&
          //   requestanimationframefunc(moveToNode(), moveToNode().scrollLeft + juli * everyPx);
          requestanimationframefunc === null || requestanimationframefunc === void 0 ? void 0 : requestanimationframefunc(moveToNode(), moveToNode().scrollLeft + juli * everyPx);
        } else {
          // console.log('当前元素在三八线左边', (visualWidth - juli) / everyPx - moveToNode().scrollLeft)
          // requestanimationframefunc &&
          //   requestanimationframefunc(
          //     moveToNode(),
          //     moveToNode().scrollLeft -
          //       (visualWidth - juli + elementClientWidth * 2) * everyPx,
          //   );
          requestanimationframefunc === null || requestanimationframefunc === void 0 ? void 0 : requestanimationframefunc(moveToNode(), moveToNode().scrollLeft - (visualWidth - juli + elementClientWidth * 2) * everyPx);
        }
      },
      className: (0, _classnames["default"])('tci-netvigator-item tci-netvigator-item-width', (_a = {}, _a["tci-netvigator-item-" + theme + "-" + display] = [theme, display], _a.studentcolor = colorTheme === 'studentactivities', _a.selected = isSelect, _a.menu = true, _a))
    }, child);
    return soupContent;
  }));
});
Netvigator.displayName = 'TCINetvigator';
var _default = exports["default"] = Netvigator;